module.exports = __webpack_public_path__ + "static/img/reviewed.5e4441c6.jpg";